"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SaldoItemView: {
        displayName: "SaldoItemView"
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: "/usr/local/ibonus/src/components/Operations/default/SaldoItemView.jsx",
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SaldoItemView = _wrapComponent("SaldoItemView")(function (_Component) {
    (0, _inherits3.default)(SaldoItemView, _Component);

    function SaldoItemView() {
        (0, _classCallCheck3.default)(this, SaldoItemView);
        return (0, _possibleConstructorReturn3.default)(this, (SaldoItemView.__proto__ || (0, _getPrototypeOf2.default)(SaldoItemView)).call(this));
    }

    (0, _createClass3.default)(SaldoItemView, [{
        key: "render",
        value: function render() {
            var item = this.props.item;


            var payClass = void 0,
                mark = void 0;

            switch (item.id_currency) {
                case 643:
                    mark = _react3.default.createElement("span", { className: "fa fa-rub" });
                    break;
                case 980:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "ukr" },
                        "\u20B4"
                    );
                    break;
                case 498:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "mdl" },
                        "L"
                    );
                    break;
                case 978:
                    mark = _react3.default.createElement("span", { className: "fa fa-eur" });
                    break;
                case 840:
                    mark = _react3.default.createElement("span", { className: "fa fa-usd" });
                    break;
                case 826:
                    mark = _react3.default.createElement("span", { className: "fa fa-gbr" });
                    break;
                case 933:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "byn" },
                        "L"
                    );
                    break;
                case 949:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "try" },
                        "\u20BA"
                    );
                    break;
                case 784:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "try" },
                        "\u20BA"
                    );
                    break;
                case 702:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "sgd" },
                        "\u20BA"
                    );
                    break;
                case 860:
                    mark = _react3.default.createElement(
                        "span",
                        { className: "uzs" },
                        "\u20BA"
                    );
                    break;
                default:
                    mark = null;
            }

            if (item.id_account != null) {

                if (item.balance_after >= item.balance_begin) {
                    payClass = "text_color_green";
                } else {
                    payClass = "text_color_red";
                }

                return _react3.default.createElement(
                    "tr",
                    { className: "table_row table_saldo" },
                    _react3.default.createElement(
                        "td",
                        { className: "saldo_mark" },
                        mark
                    ),
                    _react3.default.createElement(
                        "td",
                        { className: "text_color_green" },
                        parseFloat(item.balance_begin || 0).toFixed(2)
                    ),
                    _react3.default.createElement(
                        "td",
                        { className: "text_color_green" },
                        "+" + parseFloat(item.payin_now || 0).toFixed(2)
                    ),
                    _react3.default.createElement(
                        "td",
                        { className: "text_color_red" },
                        "-" + parseFloat(item.payout_now || 0).toFixed(2)
                    ),
                    _react3.default.createElement(
                        "td",
                        { className: "" + payClass },
                        parseFloat(item.balance_after || 0).toFixed(2)
                    )
                );
            } else {
                return null;
            }
        }
    }]);
    return SaldoItemView;
}(_react2.Component));

exports.default = SaldoItemView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Operations/default/SaldoItemView.jsx
// module id = 1701
// module chunks = 0